<template>
  <div>
    <app-cells>
      <app-checkbox
        v-if="is_sales_manager && groupDetail.type.code === 'join'"
        v-model="filter_clients"
        @change="onChangeFilter"
        label="My clients"
      />
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{'table-default--loading': table_data_loading}"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #h__diet>
        <div class="table-default__left">Diet</div>
      </template>
      <template #h__additional>
        <div class="table-default__left">Additional</div>
      </template>
      <template #full_name="{ row }">
        <div class="table-default__left">
          <router-link
            v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
            :to="{ name: 'clients-detail', params: { id: row.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.full_name }}
          </router-link>
          <div v-else class="table-default__left">{{ row.client.full_name }}</div>
        </div>
      </template>
      <template #diet="{ row }">
        <div class="table-default__column">
          <span>{{ row.client.food_preference.name }}</span>
          <div v-if="row.client.food_gluten_free || row.client.food_lactose_free || row.client.food_halal || row.client.food_no_chicken || row.client.food_no_red_meat" class="table-default__controls">
            <span v-if="row.client.food_gluten_free" class="status-tag" :style="{ 'backgroundColor': '#a865eb' }">Gluten-free</span>
            <span v-if="row.client.food_lactose_free" class="status-tag" :style="{ 'backgroundColor': '#5e99e6' }">Lactose-free</span>
            <span v-if="row.client.food_halal" class="status-tag" :style="{ 'backgroundColor': '#4cb184' }">Halal</span>
            <span v-if="row.client.food_no_chicken" class="status-tag" :style="{ 'backgroundColor': '#e6b85e' }">No chicken</span>
            <span v-if="row.client.food_no_red_meat" class="status-tag" :style="{ 'backgroundColor': '#e65e81' }">No red meat</span>
          </div>
        </div>
      </template>
      <template #food_allergy="{ row }"><span>{{ row.client.food_allergy || '-' }}</span></template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.client.group">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.client.group.name }}</div>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import { getClimbingGroupFood, getFoodPreferences } from '@/http'

export default {
  name: 'ClimbingGroupsDetailFood',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      filter_clients: true,
      table: {
        items: [],
        columns: ['full_name', 'diet', 'food_allergy', 'group'],
        options: {
          headings: {
            full_name: 'Full name',
            diet: 'Diet',
            food_allergy: 'Allergies',
            group: 'Group',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      food_options: [],
      table_data_loading: false,
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  created() {
    this.fetchItems()
    getFoodPreferences().then(res => { this.food_options = res.data })
  },
  methods: {
    onChangeFilter() {
      this.fetchItems()
    },
    fetchItems() {
      getClimbingGroupFood(this.$route.params.id, {only_visible: this.is_sales_manager ? this.filter_clients : false})
        .then(response => {
          this.table.items = response.data
          this.table_data_loading = false
        })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  },
}
</script>
